import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class ApiInfoService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) { }

  findApiInfo = (): Observable<any> =>
    this.http
      .get<any>(
        this.constants.ACTUATOR_INFO_ENDPOINT
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

}
